<template>
  <div class="page-heading">
    <div class="row">
      <div class="col-md-4">
        <h2>Permission</h2>
      </div>
      <div class="col-md-8">
        <a
          class="btn btn-primary"
          @click="redirectAnotherRoute"
          style="float: right; margin-left: 15px"
        >
          <i class="bi bi-file-plus"></i>
          Custom Permission Page
        </a>
        <button
          type="button"
          @click="getUserWiseRoleList"
          class="btn btn-secondary"
          style="float: right; margin-left: 15px"
        >
          <i class="bi bi-search"></i> Search Role
        </button>
        <multiselect
          v-model="userObject.userId"
          :closeOnSelect="true"
          :searchable="true"
          :createTag="true"
          :options-limit="30"
          :resetAfter="true"
          :options="userOption"
          :loading="true"
          placeholder="Select User"
          style="width: 300px; float: right"
        />
      </div>
    </div>
  </div>

  <div v-if="isLoading">
    <div class="text-center mt-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="select-all-btn">
          <input type="checkbox" v-model="checkAll" class="form-check-input" />
          <span> Select All</span>
        </div>
      </div>
    </div>
    <form @submit="updateRolePermission">
      <div class="row mt-3">
        <div class="col-md-12">
          <!-- Recursively call permission list -->
          <permissionList
            :permissions="frontMappedPermissionLists"
            :userPermissionList="mappedUserPermissionList"
            :padding="1"
            :checkAll="checkAll"
          ></permissionList>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button type="submit" id="update-button" class="btn btn-primary">
            <i class="bi bi-plus"></i> Update Role
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import $ from 'jquery';
import http from '../../config/axios';
import userService from '../../config/axiosUserService';
import permissionList from './permissionList.vue';

export default {
  name: 'rolePermission',
  components: {
    Multiselect,
    permissionList
  },
  data() {
    return {
      userOption: [],
      userObject: {
        userId: '',
        userPermission: []
      },
      permissionLists: [],
      frontMappedPermissionLists: [],
      // backMappedPermissionLists: [],
      internalRouteList: [],
      backEndRouteList: [],
      userPermissionList: [],
      mappedUserPermissionList: {},
      selectedUrl: [],
      checkAll: 'not_set',
      permission: '',
      urlSearch: '',
      isLoading: false
    };
  },
  created() {
    var routeList = [];
    this.$router.options.routes.forEach((data) => {
      if (data.name != 'home') {
        routeList.push(data.name);
      }
    });
    this.internalRouteList = Object.assign({}, routeList);
  },
  mounted() {
    this.getAllUserList();
    this.getUserWiseRoleList();
    this.getBackendAllRoutes();
    this.permission = localStorage.getItem('userPermission').split(',');
  },
  methods: {
    getAllUserList() {
      userService
        .get('v1/users?role=Internal User&limit=500')
        .then((response) => {
          if (response.status === 200) {
            let userList = response.data.data;
            userList.forEach((object) => {
              this.userOption.push({
                value: object.user_code,
                label: object.name
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mapPermissionList(routeList, mappedRouteList, parentRouteId = null) {
      routeList.forEach((ele) => {
        if (ele.parent_route_id == parentRouteId) {
          ele.childs = [];
          // Push the element if parent route matches
          mappedRouteList.push(ele);
          if (ele.has_child) {
            // Repeat the same process if it has childs
            this.mapPermissionList(
              routeList,
              mappedRouteList[mappedRouteList.length - 1].childs,
              ele.id
            );
          }
        }
      });
    },
    differentiateAndMapPermissionList() {
      let frontendRouteList = [];
      let backendRouteList = [];

      this.backEndRouteList.forEach((element) => {
        if (element.route_type === 'backend' && !element.parent_route_id) {
          backendRouteList.push(element);
        } else {
          frontendRouteList.push(element);
        }
      });

      this.mapPermissionList(
        frontendRouteList,
        this.frontMappedPermissionLists
      );

      // Add an extra permission row for extra backend routes
      if (backendRouteList.length > 0) {
        this.frontMappedPermissionLists.push({
          route_id: 0,
          route_name: 'Extra Backend Routes',
          has_child: 1,
          childs: backendRouteList
        });
      }
    },
    getBackendAllRoutes() {
      http
        .get('/v2/role-permission/all-frontend-routes')
        .then((response) => {
          if (response.status === 200) {
            this.backEndRouteList = response.data.data;
            this.differentiateAndMapPermissionList();
            this.permissionLists = {
              ...this.backEndRouteList,
              ...this.internalRouteList
            };
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mapUserPermissionList() {
      this.mappedUserPermissionList = {};
      if (Array.isArray(this.userPermissionList)) {
        this.userPermissionList.forEach((ele) => {
          this.mappedUserPermissionList[ele] = true;
        });
      }
    },
    getUserWiseRoleList() {
      this.isLoading = true;
      http
        .get(
          `/v2/role-permission/role-and-user-permission-by-id?role_name=Internal User&user_id=${this.userObject.userId}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.userPermissionList = response.data.data;
            this.mapUserPermissionList();
            this.checkAll = 'not_set';
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateRolePermission(e) {
      e.preventDefault();
      var list = [];
      $.each($("input[name='permissionCheckbox']:checked"), function () {
        list.push($(this).val());
      });

      const data = {
        role_name: 'Internal User',
        user_id: this.userObject.userId,
        permissionIds: list
      };

      http
        .post(`/v2/role-permission/storeById`, data)
        .then((response) => {
          if (response.status === 200) {
            this.getUserWisePermissionList();
            // this.$router.push({ name: 'trip-create' });
            this.$swal({
              title: 'Success!',
              text: 'Permissions updated successfully!',
              icon: 'success',
              type: 'success',
              showConfirmButton: false,
              timer: 500
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserWisePermissionList() {
      var user_code = localStorage.getItem('userCode');
      http
        .get(
          `/v2/role-permission/role-and-user?role_name=Internal User&user_id=${user_code}`
        )
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem(
              'userPermission',
              Object.values(response.data.data)
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    redirectAnotherRoute() {
      this.$router.push('/trip-request/partner/custom/permission/list');
    }
  },
  computed: {
    getUrlList() {
      if (this.urlSearch) {
        return Object.values(this.permissionLists).filter((permission) => {
          return permission
            .toLowerCase()
            .includes(this.urlSearch.toLowerCase());
        });
      } else {
        return this.permissionLists;
      }
    }
  }
  // watch: {
  //   frontCheckAll: function () {
  //     if ($('#frontCheckAll').is(':checked') == true) {
  //       $('.cb-element').prop('checked', true);
  //     } else {
  //       $('.cb-element').prop('checked', false);
  //     }
  //   },
  //   backCheckAll: function () {
  //     if ($('#backCheckAll').is(':checked') == true) {
  //       $('.cb-element').prop('checked', true);
  //     } else {
  //       $('.cb-element').prop('checked', false);
  //     }
  //   }
  // }
};
</script>

<style scoped>
@import '~@vueform/multiselect/themes/default.css';

.submit-button {
  background-color: #1c2457;
  border-color: #1c2457;
  font-size: 17px;
  text-align: center;
  text-decoration: none;
  font-family: Montserrat;
  font-weight: bolder;
  color: #ffffff;
}

#update-button {
  margin-bottom: 15px;
  margin-top: 15px;
}

.select-all-btn input {
  margin-left: 17px;
  margin-top: 3px;
  margin-right: 10px;
}
</style>
